<template>
    <v-card variant="flat" class="px-4 pt-3" style="border-radius: 16px;">
        <v-form ref="form" @submit.prevent="save">
            <v-row>
                <v-col class="px-4 mt-2" cols="12">
                    <div class="d-flex"
                        style="justify-content: space-between !important; align-items: center !important;">
                        <div>
                            <h2 class="main_title">
                               {{ viewType == 'edit'?'Edit': viewType == 'view'?'View':'Add' }} <span style=" color: rgb(8, 47, 177);">{{designation}}</span> 
                                </h2>
                        </div>
                        <span @click="$emit('close')"  class="mdi mdi-close"></span>
                    </div>
                </v-col>
            </v-row>

            <v-card-text>
                <v-row class="pa-0 mt-2">
                     <v-col cols="12" class="px-0 py-0 d-flex align-center justify-center">
                        <v-radio-group
                        :disabled="showReadOnly"
                        v-model="formData.status"
                        inline
                        >
                            <v-radio color="primary" label="Active" :value="'Active'" :disabled="viewType === 'view'"></v-radio>
                            <v-radio color="error" label="Inactive" :value="'Inactive'" :disabled="viewType === 'view'"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" class="py-0 px-1">
                        <v-label>Warehouse Name <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Warehouse Name')" placeholder="Warehouse Name" :disabled="viewType === 'view'" v-model="formData.warehouse_name" />
                    </v-col>

                    <v-col cols="12" class="py-0 px-1">
                        <v-label>Warehouse Code <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Warehouse Code')"  placeholder="Warehouse Code" :disabled="viewType === 'view'" v-model="formData.warehouse_code" />
                    </v-col>
                    <v-col cols="12" class="py-0 px-1">
                        <v-label>Address <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Address')" placeholder="Address" :disabled="viewType === 'view'" v-model="formData.address" />
                    </v-col>
                    <v-col cols="12" class="py-0 px-1">
                        <v-label>Mobile</v-label>
                        <TextFieldComponent  placeholder="Mobile" :disabled="viewType === 'view'"
                            v-model="formData.mobile" />
                    </v-col>

                    <v-col cols="12" class="py-0 px-1">
                        <v-label>EDI Transcations <span style="color: red;">*</span></v-label>

                        <!-- <TextFieldComponent  placeholder="EDI Transcations" :disabled="viewType === 'view'" v-model="formData.edi" /> -->
                          <div class="d-flex ga-3">
                            <TextFieldComponent placeholder="EDI" type="text"
                              :rules="getRules('EDI Transcations')"  v-model="formData.edi" :disabled="viewType === 'view'" />

                            <v-btn  @click="addChip" icon size="18" color="primary" class="rounded-circle mr-2 mt-2">
                                <v-icon size="18" :disabled="viewType === 'view'">mdi-plus</v-icon>
                            </v-btn>
                        </div>
                    </v-col>

                    <v-col cols="12" class="ch">
                        <v-chip :disabled="viewType == 'view'? true: false" v-for="(chip, index) in chips" :key="index" closable color="primary" class="ma-1"
                            @click:close="removeChip(index)">
                            {{ chip }}
                        </v-chip>
                    </v-col>

                    <!-- <v-col cols="12" class="py-0 px-1">
                        <v-label>FedEx Integrated</v-label>
                        <TextFieldComponent  placeholder="FedEx Integrated" :disabled="viewType === 'view'" v-model="formData.substitution" />
                    </v-col> -->

                    <v-col cols="12" class="py-0 px-1">
                        <v-switch
                        :disabled="viewType === 'view'"
                        color="primary"
                        v-model="formData.fedex"
                        label="FedEx Integrated"
                        ></v-switch>
                    </v-col>

                    <!-- <v-col cols="12" class="py-0 px-1">
                        <v-label>Courses Of Action</v-label>
                        <v-textarea variant="outlined"  placeholder="Courses Of Action" :disabled="viewType === 'view'" v-model="formData.courses_of_action"></v-textarea>
                    </v-col> -->
                </v-row>
            </v-card-text>
            <v-col cols="12" align="end">
                <v-btn @click="$emit('close')" class="cancel mr-3" color="gray">
                    Cancel
                </v-btn>
                <v-btn :disabled="viewType == 'view'? true: false" type="submit" class="save" color="rgb(8, 47, 177)">Save</v-btn>
            </v-col>
        </v-form>
    </v-card>
</template>

<script>
// import AutoComplete from "@/components/ui/AutoComplete.vue";
import TextFieldComponent from "@/components/TextFieldComponent.vue";

export default {
    components: {
        // AutoComplete,
        TextFieldComponent,
    },
    data: () => ({
        formData: {
            status:'Active',
            warehouse_name:'',
            warehouse_code:'',
            address:'',
            mobile:'',
            edi:[],
            fedex:false,
        },
        chips: [],
    }),
    props:['designation','wareHouseForm','viewType','index'],
    created(){
        if(this.viewType == 'edit' || this.viewType == 'view'){
            console.log(this.wareHouseForm,"wareHouseForm!!!!")
            this.formData.status = this.wareHouseForm.status,
            this.formData.warehouse_name = this.wareHouseForm.warehouse_name,
            this.formData.warehouse_code = this.wareHouseForm.warehouse_code,
            this.formData.address = this.wareHouseForm.address,
            this.formData.mobile = this.wareHouseForm.mobile,
            // this.formData.edi = this.wareHouseForm.edi,
            this.formData.fedex = this.wareHouseForm.fedex,
            this.chips = this.wareHouseForm.edi,
            // this.formData.active = this.customerForm.active
            // this.formData.created = this.customerForm.created
            // this.formData.created_by = this.customerForm.created_by
            // this.formData.deleted = this.customerForm.deleted
            // this.formData.deleted_by = this.customerForm.deleted_by
            // this.formData.id = this.customerForm.id
            console.log(this.formData,'this.@@@')
        }
    },
    
    methods:{
        // getRules(name) {
        //     if (name && name.toLowerCase() == "email") {
        //         return [
        //         (value) => !!value || "E-mail is required.",
        //         (value) => {
        //             if (/.+@.+\..+/.test(value)) {
        //             return true;
        //             }
        //             return "E-mail must be valid.";
        //         },
        //         ];
        //     }
        //     return [
        //         (value) =>
        //         (value !== null && value !== undefined && value !== "") ||
        //         `${name} is required.`,
        //     ];
        // },
        addChip() {
            if (this.formData.edi.trim() !== '') {
                this.chips.push(this.formData.edi);
                this.formData.edi = '';
                console.log(this.chips, "this.chips!!")
            }
        },
        removeChip(index) {
            this.chips.splice(index, 1);
            console.log(this.chips, "delete!!")
        },
        getRules(name) {
            if (name && name.toLowerCase() === "email") {
                return [
                    (v) => !!v || "E-mail is required.",
                    (v) => /.+@.+\..+/.test(v) || "E-mail must be valid.",
                ];
            }
            return [(v) => !!v || `${name} is required.`];
        },
        async save() {
            // alert('save')
            this.formData.edi = this.chips
            console.log(this.formData,"this.formdata###")
            const validation = await this.$refs.form.validate();
            console.log("validationnn",validation);
            
            if (!validation.valid) {
                 console.log("Form not valid");               
            } else {
                if(this.viewType == "edit"){
                this.$emit("update-location",this.formData,this.index,this.viewType)
                }
                else{
                this.$emit("save", this.formData,this.designation);
                }
                this.formData = {};
                this.$emit("close");
            }
        },
    },
}

</script>

<style scoped>
.v-label {
    margin-bottom: 3px;
    font-size: 14px;
    opacity: 1;
    font-weight: 600;
}

.main_title {
    font-size: 16px;
    font-weight: 600;
}

.v-btn-toggle .v-btn {
    background-color: #E9DFFF;

}

.v-btn-toggle {
    height: 32px !important;
}
</style>